import firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/firestore';
import 'firebase/analytics'

// Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  var firebaseConfig = {
    apiKey: "AIzaSyDwd3wJSSEHrdtlZSiR0tp_iJt368AuJW4",
    authDomain: "tasveer-hmp.firebaseapp.com",
    projectId: "tasveer-hmp",
    storageBucket: "tasveer-hmp.appspot.com",
    messagingSenderId: "269912403178",
    appId: "1:269912403178:web:54c66c97d14a8c21ab7b93",
    measurementId: "G-HSZ34FK2KX"

  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();



  const tasveerStorage = firebase.storage();
  const tasveerStore = firebase.firestore();
  const timestamp = firebase.firestore.FieldValue.serverTimestamp;


  export {tasveerStorage, tasveerStore, timestamp};
